export default __webpack_public_path__ + "7489a2fbfb9bfe70442031a27fb57a21.ttf";